export const ROUTE_INFORMATION = `${process.env.PUBLIC_URL}/`;
export const ROUTE_DOCS_EXTRACT = `${process.env.PUBLIC_URL}/check/`;
export const ROUTE_DOCS_EXTRACT_ID = `${process.env.PUBLIC_URL}/check/:id`;
export const ROUTE_QR_CODE_SCANER = `${process.env.PUBLIC_URL}/qr-code`;
